import { render } from "./TransplantSectionDetailsEMROATS.vue?vue&type=template&id=748a5e8a&scoped=true"
import script from "./TransplantSectionDetailsEMROATS.vue?vue&type=script&lang=js"
export * from "./TransplantSectionDetailsEMROATS.vue?vue&type=script&lang=js"

import "./TransplantSectionDetailsEMROATS.vue?vue&type=style&index=0&id=748a5e8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748a5e8a"],['__file',"src/components/TransplantSectionDetailsEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "748a5e8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('748a5e8a', __exports__)) {
    api.reload('748a5e8a', __exports__)
  }
  
  module.hot.accept("./TransplantSectionDetailsEMROATS.vue?vue&type=template&id=748a5e8a&scoped=true", () => {
    api.rerender('748a5e8a', render)
  })

}


export default __exports__